import React, { createContext, useContext, useState } from 'react';
export var initialValues = { isBookButtonInView: false, setIsBookButtonInView: function (bool) { } };
export var StickyFooterContext = createContext(initialValues);
export var StickyFooterProvider = function (_a) {
    var children = _a.children;
    var _b = useState(false), isBookButtonInView = _b[0], setIsBookButtonInView = _b[1];
    return (React.createElement(StickyFooterContext.Provider, { value: { isBookButtonInView: isBookButtonInView, setIsBookButtonInView: setIsBookButtonInView } }, children));
};
export var useStickyFooter = function () { return useContext(StickyFooterContext); };
